import React from "react";

const TemplateThree = () => {
    return <div>TemplateThree</div>;
};

export default TemplateThree;
